// Company details shown in the landing page footer and throughout the legal
// pages. One place to change them all.
//
// No data protection officer is named, deliberately. A DPO is only required
// for public authorities, for core activities that are large-scale systematic
// monitoring, or for large-scale special-category data - none of which this is.
// What a privacy notice must give is the CONTROLLER's identity and contact
// details, and the controller is the company: the name, registered office and
// privacy address below satisfy that without publishing an individual's name.
export const LEGAL = {
  companyName: 'Your Data Your AI Ltd',
  companyNumber: '17494468',
  registeredIn: 'England & Wales',
  registeredAddress: '66 Paul Street, London, EC2A 4NA, United Kingdom',
  contactEmail: 'hello@yourdatayourai.com',
  supportEmail: 'support@yourdatayourai.com',
  privacyEmail: 'privacy@yourdatayourai.com',
  // Empty until the ICO issues one - the privacy policy prints the sentence
  // only when this is set, rather than showing a placeholder where a
  // registration number belongs.
  icoRegistrationNumber: '',
};

// Display copy only. The backend's plans.js is the source of truth for limits;
// these tiers mirror it for the pricing table.
//
// Every line here must be something the product actually does. This table used
// to advertise advanced reporting, API access, SSO/SAML, an audit log and
// priority support, none of which exist - they were flags declared in plans.js
// and read by nothing, and they were being sold from the front page.
//
// "Unlimited questions" is true and worth saying plainly: customers bring their
// own AI key, so asking costs us nothing and there is no usage meter anywhere
// in the code. It is a real difference from every competitor who has to charge
// per query, and it is only safe to claim while that stays the case.
export const TIERS = [
  {
    id: 'starter',
    name: 'Starter',
    price: '£29',
    cadence: '/month',
    blurb: 'For small teams getting started.',
    limits: ['3 projects', '2 agents', '5 users'],
    features: ['Unlimited questions', 'Answers cited to the page', 'Bring your own AI key'],
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '£99',
    cadence: '/month',
    blurb: 'For growing delivery teams.',
    highlight: true,
    limits: ['25 projects', '10 agents', '25 users'],
    features: ['Everything in Starter', 'Custom agents', 'Connections to your other systems'],
  },
  {
    id: 'enterprise',
    // Not a self-serve purchase. The card renders a link to the contact
    // section instead of a checkout button - without this it offered to start
    // a free trial of a tier with no price, reading "Free for 7 days, then
    // Let's talk", and would have charged whatever number happened to be in
    // Stripe for unlimited everything.
    contact: true,
    name: 'Enterprise',
    price: "Let's talk",
    cadence: '',
    blurb: 'Unlimited scale, with your data on its own infrastructure.',
    limits: ['Unlimited projects', 'Unlimited agents', 'Unlimited users'],
    features: ['Everything in Pro', 'Dedicated search service', 'Isolated storage'],
  },
];
